import {
  AdminsView,
  ChartingSettingsView,
  BugReportsView,
  ContactView,
  DeleteAccountView,
  FaxesView,
  getAdminAssessmentRedirectView,
  getAdminDashboardPaths,
  getProfilePaths,
  InvoicesView,
  PatientFilesView,
  RedirectView,
  SignInRedirect,
  SignInView,
  SiteErrorsView,
  TemplatesView,
  View,
} from '@hb/react-web'
import { adminAccess, GYN_ENABLED, superAdminAccess, userAccess } from '@hb/shared'
import { AdminDashboard } from './Admin/AdminDashboard'
import { InsurersView } from './Admin/Insurers/InsurersView'
import { AdminPracticesView } from './Admin/Midwives/AdminPracticesView'
import { AuthActionsView } from './Views/Auth/AuthActionsView'
import { MyConsentForms } from './Views/ConsentForms/MyConsentForms'
import { MyDocuments } from './Views/Documents/MyDocuments'
import FormsView from './Views/Forms/FormsView'
import { FormsViewRedirect } from './Views/Forms/FormsViewRedirect'
import { GynCareView } from './Views/GYN/GynCareView'
import { GynIntakeFormView } from './Views/GYN/GynIntakeFormView'
import HomeView from './Views/Home/HomeView'
import { PrivacyPolicyView } from './Views/Legal/PrivacyPolicy'
import PatientsView from './Views/Patients/PatientsView'
import ProvidersView from './Views/Providers/ProvidersView'
import ResourcesView from './Views/Resources/ResourcesView'

export const views: View[] = [
  {
    name: 'Home',
    path: '/',
    component: HomeView,
    onMenu: true,
  },
  {
    name: 'Patients',
    path: '/patients',
    component: PatientsView,
    onMenu: true,
  },
  {
    name: 'Providers',
    path: '/providers',
    component: ProvidersView,
    onMenu: true,
  },
  {
    name: 'FAQ',
    path: '/faq',
    component: ResourcesView,
    onMenu: true,
  },
  {
    name: 'Privacy Policy',
    path: '/privacy',
    component: PrivacyPolicyView,
    onMenu: true,
  },
  {
    name: 'Contact',
    path: '/contact',
    component: ContactView,
    onMenu: true,
  },
  {
    name: 'Sign In',
    path: '/sign-in',
    component: SignInView,
    onMenu: false,
  },
  {
    name: 'Sign in Redirect',
    path: '/sign-in/:inviteId',
    component: SignInRedirect,
  },
  {
    name: 'Pregnancy',
    id: 'pregnancy',
    access: userAccess,
    path: ['/pregnancy', '/pregnancy/:assessmentId'],
    signIn: true,
    component: FormsView,
    onMenu: true,
  },
  ...(GYN_ENABLED
    ? [
        {
          name: 'GYN Care',
          id: 'gyn',
          access: userAccess,
          signIn: true,
          path: '/gyn',
          component: GynCareView,
          onMenu: true,
        },
      ]
    : []),
  {
    name: 'Patient Assessment Redirect',
    path: ['/assessment', '/assessment/:assessmentId'],
    component: FormsViewRedirect,
  },
  {
    name: 'Documents',
    path: ['/documents', '/documents/:documentId'],
    access: userAccess,
    signIn: true,
    component: MyDocuments,
    onMenu: true,
  },
  {
    name: 'Consent Forms',
    path: ['/consent-forms', '/consent-forms/:consentFormId'],
    access: userAccess,
    signIn: true,
    component: MyConsentForms,
    onMenu: true,
  },
  {
    name: 'Files',
    path: '/files',
    access: userAccess,
    signIn: true,
    component: PatientFilesView,
    onMenu: true,
  },
  {
    name: 'Admin Dashboard',
    path: getAdminDashboardPaths('app'),
    access: adminAccess,
    component: AdminDashboard,
    onMenu: true,
  },
  getAdminAssessmentRedirectView('app'),
  {
    name: 'Templates',
    path: ['/admin/templates', '/admin/templates/:templateId'],
    access: adminAccess,
    component: TemplatesView,
    onMenu: true,
  },
  {
    name: 'Providers',
    path: '/admin/providers',
    access: adminAccess,
    component: AdminPracticesView,
    onMenu: true,
  },
  {
    name: 'Insurers',
    path: '/admin/insurers',
    access: adminAccess,
    component: InsurersView,
    onMenu: true,
  },
  {
    name: 'Admins',
    path: ['/admin/admins', '/admin/admins/:adminId', '/admin/admins/:adminId/:displayedItem'],
    access: adminAccess,
    component: AdminsView,
    onMenu: true,
  },
  {
    name: 'Faxes',
    path: ['/admin/fax', ...getProfilePaths('/admin/fax/:faxType'), '/admin/fax/:faxType/:faxId'],
    access: adminAccess,
    component: FaxesView,
    onMenu: true,
  },
  {
    name: 'Invoices',
    path: [
      '/super-admin/invoices',
      '/super-admin/invoices/:invoicesTab',
      ...getProfilePaths('/super-admin/invoices/:invoicesTab/:invoiceId'),
    ],
    access: superAdminAccess,
    onMenu: true,
    component: InvoicesView,
  },
  {
    name: 'Charting Settings',
    path: '/super-admin/charting-settings',
    access: superAdminAccess,
    component: ChartingSettingsView,
    onMenu: true,
  },
  {
    name: 'Site Errors',
    path: '/admin/site-errors',
    access: adminAccess,
    component: SiteErrorsView,
  },
  {
    name: 'Bug Reports',
    path: ['/admin/bug-reports', '/admin/bug-reports/:bugReportId'],
    access: adminAccess,
    component: BugReportsView,
  },
  {
    name: 'GYN Intake Form',
    path: '/gyn-intake-form',
    component: GynIntakeFormView,
  },
  {
    name: 'Auth Actions',
    path: ['/auth-action'],
    component: AuthActionsView,
  },
  {
    name: 'Delete Account',
    path: '/delete-account',
    component: DeleteAccountView,
  },
  {
    name: 'Redirect',
    path: '/*',
    component: RedirectView,
  },
]
